module.exports = __webpack_public_path__ + "static/img/53.a59af82b.gif";